export enum SiglaTemplateDTO {
    UserCourseProgressionUpdated = "UserCourseProgressionUpdated",
    COMPLETION_CERTIFICATE = "COMPLETION_CERTIFICATE",
    Achievement = "Achievement",
    ExamWaitingSentAutoMarking = "ExamWaitingSentAutoMarking",
    EXAM_CORRECTED = "EXAM_CORRECTED",
    EXAM_WAITING_MARK = "EXAM_WAITING_MARK",
    UserImportCompleted = "UserImportCompleted",
    UserExportCompleted = "UserExportCompleted",
    DOWNLOAD_CERTIFICATES = "DOWNLOAD_CERTIFICATES",
    APPNotifications = "APPNotifications",
    UserSaved = "USER_SAVED"
}
